import { render, staticRenderFns } from "./SlideCopy.vue?vue&type=template&id=478b2850&scoped=true&"
import script from "./SlideCopy.vue?vue&type=script&lang=js&"
export * from "./SlideCopy.vue?vue&type=script&lang=js&"
import style0 from "./SlideCopy.vue?vue&type=style&index=0&id=478b2850&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478b2850",
  null
  
)

export default component.exports